/**
 * @generated SignedSource<<3b5183b8993a2b1ca2b85c2870a5f4ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CurrencyDropdown_viewer$data = {
  readonly countries: ReadonlyArray<{
    readonly isoCode: string | null;
    readonly name: string | null;
  } | null> | null;
  readonly " $fragmentType": "CurrencyDropdown_viewer";
};
export type CurrencyDropdown_viewer$key = {
  readonly " $data"?: CurrencyDropdown_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurrencyDropdown_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrencyDropdown_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CountryListNode",
      "kind": "LinkedField",
      "name": "countries",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8f28166baa028ad4e0406f7dd383e6cd";

export default node;
